module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/BonusGirl-52b361cd5e0ef9728ef0b5da6ba00ca6.png";